import type { Map as MapboxMap } from 'mapbox-gl'

import {
  expandBoundsByPadding,
  isFiniteMapBounds,
  mapboxBoundsToMapBounds,
  subtractPaddingFromBounds,
} from 'lib/maps/bounds'
import type { MapBounds } from 'lib/maps/types'

import {
  getZoomAwareSearchBoundsInsetPadding,
  getZoomAwareSearchBoundsTolerancePadding,
} from './searchBoundsConfig'

export function getSearchBoundsForMap(nextMap: MapboxMap): MapBounds | undefined {
  const rawMapboxBounds = nextMap.getBounds()
  const mapContainer = nextMap.getContainer()

  if (!rawMapboxBounds || !mapContainer) {
    return undefined
  }

  const zoom = nextMap.getZoom()
  const mapContainerRect = mapContainer.getBoundingClientRect()
  const rawBounds = mapboxBoundsToMapBounds(rawMapboxBounds)
  const insetBounds = subtractPaddingFromBounds(
    rawBounds,
    mapContainerRect,
    getZoomAwareSearchBoundsInsetPadding(zoom),
  )
  const finalBounds = expandBoundsByPadding(
    insetBounds,
    mapContainerRect,
    getZoomAwareSearchBoundsTolerancePadding(zoom),
  )

  if (!isFiniteMapBounds(rawBounds) || !isFiniteMapBounds(insetBounds) || !isFiniteMapBounds(finalBounds)) {
    return undefined
  }

  return finalBounds
}
